export const MODE_KEY = 'awThemeMode'; // Same as @rtkwlf/fenrir-react

export type PaletteMode = 'light' | 'dark';
export type FenrirThemeMode = PaletteMode | 'system';
